module.exports = __webpack_public_path__ + "static/media/pfjs.6d1cb93e.png";